import { apiFetch } from './apiClient';

/* Perfis de tributação são POR CLIENTE: guardam o conjunto fixo de códigos
   de um tipo de serviço (CTN, NBS, código da operação, município de
   prestação, alíquota), pra não redigitar tudo a cada emissão. */
export const listarPerfisNf = (clienteId) => apiFetch(`/nf-perfis/${clienteId}`);

export const criarPerfilNf = (clienteId, dados) =>
  apiFetch(`/nf-perfis/${clienteId}`, { method: 'POST', body: JSON.stringify(dados) });

export const atualizarPerfilNf = (clienteId, id, dados) =>
  apiFetch(`/nf-perfis/${clienteId}/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });

export const excluirPerfilNf = (clienteId, id) =>
  apiFetch(`/nf-perfis/${clienteId}/${id}`, { method: 'DELETE' });

/* Faixas de série do Padrão Nacional, por tipo de emissão. Nosso emissor
   transmite por WEBSERVICE, então série fora de 1–49999 é recusada pela
   Receita com o erro E0010 (série fora da faixa do tipo de emissor) --
   vale avisar no cadastro em vez de deixar descobrir na hora de emitir. */
export const SERIE_WEBSERVICE = { min: 1, max: 49999 };

export function avisoSerieDps(serie) {
  const n = Number(String(serie ?? '').replace(/\D/g, ''));
  if (!n) return null;
  if (n >= SERIE_WEBSERVICE.min && n <= SERIE_WEBSERVICE.max) return null;
  if (n >= 50000 && n <= 69999) return 'Série 50000–69999 é do emissor móvel. Nosso sistema emite por webservice, que exige série entre 1 e 49999.';
  if (n >= 70000 && n <= 79999) return 'Série 70000–79999 é do Portal Nacional. Nosso sistema emite por webservice, que exige série entre 1 e 49999.';
  return 'Série fora da faixa aceita no webservice (1 a 49999). A Receita recusa com o erro E0010.';
}
